import { EngageLibraryRowModel, EngageLibrarySyncActionEnum } from './engage-library-types';
import { engageLibraryRowKey, isMembershipChecked, membershipLockReason } from './engage-library-utils';
import styles from './EngageLibraryBulkSelect.module.css';

interface EngageLibraryBulkSelectProps {
  rows: EngageLibraryRowModel[];
  pendingActionByKey: Map<string, EngageLibrarySyncActionEnum>;
  isSaving: boolean;
  onSetMembership: (rows: EngageLibraryRowModel[], desiredMembership: boolean) => void;
}

/** Checks or unchecks every row the current filters show; rows hidden by filters are left alone. */
export function EngageLibraryBulkSelect({
  rows,
  pendingActionByKey,
  isSaving,
  onSetMembership,
}: EngageLibraryBulkSelectProps) {
  const changeableRows = rows.filter(row => !membershipLockReason(row));
  const checkedRowCount = changeableRows.filter(row =>
    isMembershipChecked(row, pendingActionByKey.get(engageLibraryRowKey(row))),
  ).length;
  const uncheckedRowCount = changeableRows.length - checkedRowCount;
  const canSelectAll = uncheckedRowCount > 0 && !isSaving;
  const canDeselectAll = checkedRowCount > 0 && !isSaving;
  const selectAllLabel = uncheckedRowCount > 0 ? `Select all (${uncheckedRowCount})` : 'Select all';
  const deselectAllLabel = checkedRowCount > 0 ? `Deselect all (${checkedRowCount})` : 'Deselect all';

  return (
    <div className={styles.bulkSelect}>
      <button
        type="button"
        className={styles.bulkButton}
        disabled={!canSelectAll}
        onClick={() => onSetMembership(changeableRows, true)}>
        {selectAllLabel}
      </button>
      <button
        type="button"
        className={styles.bulkButton}
        disabled={!canDeselectAll}
        onClick={() => onSetMembership(changeableRows, false)}>
        {deselectAllLabel}
      </button>
    </div>
  );
}
